// extracted by mini-css-extract-plugin
export default {"root":"TableBody_root__q76Sj"};